import Request from './Request'

export default class M1AdvisorService {
  static async listActive(clientId) {
    const response = await Request.get('/api/m1-advisors', { client_id: clientId })
    return Array.isArray(response?.data) ? response.data : []
  }

  static async list(params = {}) {
    const response = await Request.get('/api/admin/m1-advisors', params)
    return Array.isArray(response?.data) ? response.data : []
  }

  static create(formData) {
    return Request.formPost('/api/admin/m1-advisors', formData)
  }

  static update(id, formData) {
    return Request.formPost(`/api/admin/m1-advisors/${id}`, formData)
  }

  static remove(id) {
    return Request._delete(`/api/admin/m1-advisors/${id}`)
  }
}

